module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Google_Home.a2869071.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Google_Home.svg
// module id = 3431
// module chunks = 0